import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "经核查，该网站（游戏）为已获得传奇官方正版许可！", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "网站名称：", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "网  站：", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "许可编码：", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "许可时间：", -1)
const _hoisted_6 = { style: {"color":"#cc2a2e"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 至 ")
const _hoisted_8 = { style: {"color":"#cc2a2e"} }


import { License } from "@/data/index.type";
import { getHost } from "@/tools";
import Stars from "@/components/Stars.vue";
interface LicenseCertificationProps {
  data: License;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseCertification',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: License;
}



const onClick = () => {
  window.open(props.data.url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['stars-wrap'])
    }, [
      _createVNode(Stars, {
        size: __props.data.star
      }, null, 8, ["size"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content)
    }, [
      _hoisted_1,
      _createElementVNode("p", null, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(__props.data.title), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_unref(getHost)(__props.data.url)), 1),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.$style.enter),
          onClick: onClick
        }, "进入网站", 2)
      ]),
      _createElementVNode("p", null, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(__props.data.licensecode), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.data.startTime), 1),
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.data.endTime), 1)
      ])
    ], 2)
  ], 2))
}
}

})